import React, { ReactNode } from "react";
import { TableColumn } from "../../../types/table/TableColumn";
import { RiArrowUpDownLine } from "react-icons/ri";
import { BsArrowUp, BsArrowDown } from "react-icons/bs";
import { CheckBox } from "shared/components/checkbox/CheckBox";
import { OptionsCheckBox } from "shared/components/checkbox/OptionsCheckBox";
import { OpcoesSelecionaveisCheckBox } from "types/OpcoesSelecionaveisCheckBoxType";

interface TableHeaderProps {
  id: string;
  colunas: TableColumn[];
  renderCheckBox: boolean;
  tipoCheckBox?: "SELECT_OPTIONS" | "SELECT_ALL";
  ordernarPorColuna?: string;
  ordenacaoAscOuDesc?: "ASC" | "DESC";
  ordenarRegistrosFunction?: (columnId: string) => void;
  onChangeCheckBox?: (opcao: OpcoesSelecionaveisCheckBox) => void;
  disabledCheckBox?: boolean;
  checkedCheckBox?: boolean;
  isIndeterminateCheckBox?: boolean;
}

export const TableHeader: React.FC<TableHeaderProps> = (props) => {
  const renderColunas = (colunas: TableColumn[]): ReactNode[] => {
    const tableColumns = colunas.map((coluna: TableColumn) => {
      if (coluna.hideColumn) {
        return;
      }
      return renderTableHead(coluna);
    });

    if (props.renderCheckBox) {
      tableColumns.unshift(renderCheckBoxSelect());
    }

    return tableColumns;
  };

  const renderTableHead = (coluna: TableColumn): ReactNode => {
    const styleColuna = getStyleColuna(coluna);
    return (
      <th
        id={coluna.id}
        key={`tableColumn-${coluna.label}-${coluna.id}`}
        className={"table-column-gc"}
        style={styleColuna}
        onClick={() => {
          if (coluna.isOrdenavel && props.ordenarRegistrosFunction !== undefined) {
            props.ordenarRegistrosFunction(coluna.id);
          }
        }}
      >
        {renderTituloColuna(coluna)}
      </th>
    );
  };

  const renderTituloColuna = (coluna: TableColumn): ReactNode => {
    return (
      <span>
        {" "}
        {coluna.label} {coluna.isOrdenavel && renderIconeOrdenacao(coluna)}
        {coluna.hint && renderHintColuna(coluna)}
      </span>
    );
  };
  const renderIconeOrdenacao = (coluna: TableColumn): ReactNode => {
    const isRegistrosOrdenadosPorEssaColuna = props.ordernarPorColuna === coluna.id;

    if (isRegistrosOrdenadosPorEssaColuna && props.ordenacaoAscOuDesc) {
      return props.ordenacaoAscOuDesc === "ASC" ? (
        <BsArrowDown className={"icone-ordenacao"} color="#389cf8" size={16} />
      ) : (
        <BsArrowUp className={"icone-ordenacao"} color="#389cf8" size={16} />
      );
    }

    return <RiArrowUpDownLine color="inherit" className={"icone-ordenacao"} size={16} />;
  };

  const renderHintColuna = (coluna: TableColumn): ReactNode => {
    //A DEFINIR QUAL LIB DE TOOLTIP SERÁ USADO
    return <span>com hint</span>;
  };

  const getStyleColuna = (coluna: TableColumn) => {
    let style = {};
    if (coluna.width) {
      style = { width: coluna.width };
    }
    if (coluna.isOrdenavel) {
      style = { ...style, cursor: "pointer" };
    }
    if (coluna.textAlign) {
      style = { ...style, textAlign: coluna.textAlign };
    }

    return style;
  };

  const renderCheckBoxSelectAll = (): ReactNode => {
    return (
      <span>
        <CheckBox
          usarValidacaoParaFormulario={false}
          id="checkBox-selecionarTodos"
          disabled={props.disabledCheckBox || false}
          checked={props.checkedCheckBox}
          onChange={(isChecked) =>
            props.onChangeCheckBox && props.onChangeCheckBox(isChecked ? "TODAS_PAGINA" : "NENHUMA")
          }
        />
      </span>
    );
  };

  const renderCheckBoxSelectOptions = (): ReactNode => {
    return (
      <span>
        <OptionsCheckBox
          id="checkBox-selectOptions"
          disabled={props.disabledCheckBox || false}
          checked={props.checkedCheckBox || false}
          indeterminate={props.isIndeterminateCheckBox || false}
          onChange={(opcao) => props.onChangeCheckBox && props.onChangeCheckBox(opcao)}
        />
      </span>
    );
  };

  const renderCheckBoxSelect = (): ReactNode => {
    return (
      <th
        id={`checkBox-${props.id}}`}
        className={"table-column-gc coluna-checkBox"}
        key={`tableColumn-${props.id}-checkBox`}
      >
        {props.tipoCheckBox === "SELECT_ALL" ? renderCheckBoxSelectAll() : renderCheckBoxSelectOptions()}
      </th>
    );
  };

  return (
    <thead>
      <tr className={"table-header"}>{renderColunas(props.colunas)}</tr>
    </thead>
  );
};
